<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.49977 17.2074L16.0345 4.72059L20.2785 8.9646L7.79232 21.4995L3.49998 21.4995L3.49977 17.2074Z"
      stroke="currentColor"
    />
    <path
      d="M17.8031 2.95429C18.3889 2.3685 19.3386 2.3685 19.9244 2.95429L22.0457 5.07561C22.6315 5.6614 22.6315 6.61114 22.0457 7.19693L20.278 8.9647L16.0353 4.72206L17.8031 2.95429Z"
      stroke="currentColor"
    />
  </svg>
</template>
